import React from 'react'

import { useIsMobile } from 'src/shared/hooks/use-mobile'

interface CalendarDateProps {
  date: Date | string
}

export const CalendarDate: React.FC<CalendarDateProps> = ({ date }) => {
  const isMobile = useIsMobile()

  const dateObj = typeof date === 'string' ? new Date(date) : date

  // Format month (3-letter abbreviation)
  const month = dateObj.toLocaleString('en-US', { month: 'short' }).toUpperCase()

  // Format day (numeric)
  const day = dateObj.getDate()

  // Format day of week (3-letter abbreviation)
  const dayOfWeek = dateObj.toLocaleString('en-US', { weekday: 'short' }).toUpperCase()

  // Format time (HH:MM AM/PM)
  const time = dateObj.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })

  return (
    <div className="flex flex-col items-center">
      <div
        className={`flex flex-col items-center rounded-lg bg-accent p-1 text-center ${
          isMobile ? 'min-w-12' : 'min-w-16'
        }`}
      >
        <div className="w-full rounded-t-lg bg-muted px-2 py-1 text-xs font-semibold text-primary-foreground">
          {month}
        </div>
        <div className={`font-bold text-muted ${isMobile ? 'text-xl' : 'text-2xl'}`}>{day}</div>
        <div className="pb-1 text-xs font-medium text-muted">{dayOfWeek}</div>
      </div>
      <div className={`mt-${isMobile ? '0.5' : '1'} ${isMobile ? 'text-[10px]' : 'text-xs'}`}>{time}</div>
    </div>
  )
}
